import { useEffect, useState } from "react";
import { ACTIONS, useAuth } from "../../../providers/AuthProviders";

export function useAuthentication() {
  const [load, setLoad] = useState(true);
  const { dispatch, state } = useAuth();
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const userString = localStorage.getItem("currentUser");

    if (token && userString) {
      const user = JSON.parse(userString);
      dispatch({
        type: ACTIONS.SET_AUTHENTICATED,
        payload: {
          authenticated: true,
          currentUser: user,
        },
      });
    } else {
      dispatch({
        type: ACTIONS.SET_AUTHENTICATED,
        payload: { authenticated: false },
      });
    }

    setLoad(false);
  }, [dispatch]);

  return { load, isAuth: state.authenticated };
}
